import CollapsibleCard from './CollapsibleCard';

export default CollapsibleCard;
